import { useCallback } from 'react';
import type { DialogsDrawerScope, DialogsDrawerSpec } from './store';
import { useDialogsDrawerStore } from './store';

/** Адрес среза и его заголовок без отбора страницы — отбор хук подставляет сам. */
export type DialogsDrawerTarget = Omit<DialogsDrawerSpec, 'scope'>;

/**
 * Проваливание в диалоги среза в отборе страницы: показатели среза должны совпасть с теми,
 * что видны на самой странице, поэтому отбор к адресу среза подставляется в одном месте.
 */
export const useOpenDialogsDrawer = (scope: DialogsDrawerScope) => {
  const open = useDialogsDrawerStore((store) => store.open);
  const { filters, dateFrom, dateTo, target } = scope;

  return useCallback(
    (drawerTarget: DialogsDrawerTarget) => open({ ...drawerTarget, scope: { filters, dateFrom, dateTo, target } }),
    [open, filters, dateFrom, dateTo, target],
  );
};
